/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Studyprograms_Study_Greek_Philology20Inputs */

const en__field__enum_studyprograms_study_greek_philology20 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Greek_Philology20Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Greek Philology`)
};

const de__field__enum_studyprograms_study_greek_philology20 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Greek_Philology20Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Griechische Philologie`)
};

/**
* | output |
* | --- |
* | "Greek Philology" |
*
* @param {_Field__Enum_Studyprograms_Study_Greek_Philology20Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_studyprograms_study_greek_philology20 = /** @type {((inputs?: _Field__Enum_Studyprograms_Study_Greek_Philology20Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Studyprograms_Study_Greek_Philology20Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_studyprograms_study_greek_philology20(inputs)
	return de__field__enum_studyprograms_study_greek_philology20(inputs)
});
export { _field__enum_studyprograms_study_greek_philology20 as "_field__enum_studyPrograms_STUDY_GREEK_PHILOLOGY" }